export default "__VITE_ASSET__DOjiWTyb__"